import React, { useState } from "react";
import { Row, Col, Card, CardBody, Table, Modal, ModalHeader, ModalBody, Spinner, Input, Label, UncontrolledTooltip, Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "../../staticfiles/css/rw-rule-playground.css";
import { imagePrefix, useImageModal } from "../utils";
import { filterTableData, downloadTableData } from "./TableUtils";


const HarmonicDiscountTable = ({
  dataFetching,
  startDate,
  endDate,
  totalData,
}) => {
  const imageModal = useImageModal('reactstrap');

  const [storewideFilter, setStorewideFilter] = useState("All");
  const [steepFilter, setSteepFilter] = useState("All");
  const [significantFilter, setSignificantFilter] = useState("All");
  const [clearanceFilter, setClearanceFilter] = useState("All");
  const [desperationFilter, setDesperationFilter] = useState("All");

  const filteredData = filterTableData(totalData, {
    storewide: storewideFilter,
    steep: steepFilter,
    significant: significantFilter,
    clearance: clearanceFilter,
    desperation: desperationFilter,
  });

  const columns = [
    {
      dataField: "cached_harmonic_id",
      hidden: true,
    },
    {
      dataField: "feed_id",
      hidden: true,
    },
    {
      dataField: "product_type",
      hidden: true,
    },
    {
      dataField: "holiday_tag",
      hidden: true,
    },
    {
      dataField: "free_ship_condition",
      hidden: true,
    },
    {
      dataField: "last_update",
      hidden: true,
    },
    {
      dataField: "email_image",
      hidden: true,
    },
    {
      dataField: "has_rule",
      hidden: true,
    },
    {
      dataField: "min_discount_pct_rule",
      hidden: true,
    },
    {
      dataField: "max_discount_pct_rule",
      hidden: true,
    },
    {
      dataField: "effective_discount_pct_rule",
      hidden: true,
    },
    {
      dataField: "state_discount_rule",
      hidden: true,
    },
    {
      dataField: "product_type_rule",
      hidden: true,
    },
    {
      dataField: "is_storewide_rule",
      hidden: true,
    },
    {
      dataField: "is_steep_rule",
      hidden: true,
    },
    {
      dataField: "is_significant_rule",
      hidden: true,
    },
    {
      dataField: "holiday_tag_rule",
      hidden: true,
    },
    {
      dataField: "free_ship_condition_rule",
      hidden: true,
    },
    {
      dataField: "min_discount_pct_nlp",
      hidden: true,
    },
    {
      dataField: "max_discount_pct_nlp",
      hidden: true,
    },
    {
      dataField: "effective_discount_pct_nlp",
      hidden: true,
    },
    {
      dataField: "state_discount_nlp",
      hidden: true,
    },
    {
      dataField: "product_type_nlp",
      hidden: true,
    },
    {
      dataField: "is_storewide_nlp",
      hidden: true,
    },
    {
      dataField: "is_steep_nlp",
      hidden: true,
    },
    {
      dataField: "is_significant_nlp",
      hidden: true,
    },
    {
      dataField: "holiday_tag_nlp",
      hidden: true,
    },
    {
      dataField: "free_ship_condition_nlp",
      hidden: true,
    },
    {
      dataField: "nlp_editor",
      hidden: true,
    },
    {
      dataField: "is_clearance",
      hidden: true,
    },
    {
      dataField: "subject",
      text: "Subject",
      sort: true,
      formatter: (cell, row) => {
        return (
          <React.Fragment>
            {cell}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                imageModal.openImageModal(imagePrefix + row.feed_id);
              }}
            >
              <i className="bi bi-search" style={{ marginRight: "5px" }}></i>
            </a>
          </React.Fragment>
        );
      },
    },
    {
      dataField: "category",
      text: "Category",
      sort: true,
    },
    {
      dataField: "start_date",
      text: "Start Date",
      sort: true,
    },
    {
      dataField: "end_date",
      text: "End Date",
      sort: true,
    },
    {
      dataField: "total_volume",
      text: "Volume",
      sort: true,
      formatter: (cell, row) => {
        return cell.toLocaleString();
      },
    },
    {
      dataField: "min_discount_pct",
      text: "Min %",
      sort: true,
    },
    {
      dataField: "max_discount_pct",
      text: "Max %",
      sort: true,
    },
    {
      dataField: "effective_discount_pct",
      text: "Effective %",
      sort: true,
    },
    {
      dataField: "state_discount",
      text: "State",
      sort: true,
    },
    {
      dataField: "state_discount_val",
      text: "State Discount Value",
      sort: true,
    },
    {
      dataField: "is_storewide",
      text: "Storewide",
      sort: true,
    },
    {
      dataField: "is_steep",
      text: "Steep",
      sort: true,
    },
    {
      dataField: "is_significant",
      text: "Significant",
      sort: true,
    },
    {
      dataField: "is_clearance",
      text: "Clearance",
      sort: true,
    },
    {
      dataField: "nlp_badwords",
      text: "Desperation",
      sort: true,
    },
  ];

  if (dataFetching) {
    return (
      <Card>
        <CardBody>
          <h4 className="header-title">
            <Row>
              <Col md={12}>Selected Time: {startDate + " ~ " + endDate}</Col>
            </Row>
          </h4>
          <h4>Fetching Data...</h4>
        </CardBody>
      </Card>
    );
  } else if (totalData.length === 0) {
    return (
      <Card>
        <CardBody>
          <h4 className="header-title">
            <Row>
              <Col md={12}>Selected Time: {startDate + " ~ " + endDate}</Col>
            </Row>
          </h4>
        </CardBody>
      </Card>
    );
  }

  const { SearchBar } = Search;

  return (
    <div>
      <Card>
        <CardBody>
          <h4 className="header-title">
            <Row>
              <Col md={12}>
                Selected Time:
                {startDate + " ~ " + endDate}
              </Col>
            </Row>
          </h4>
          <ToolkitProvider
            bootstrap4
            keyField="cached_harmonic_id"
            data={filteredData}
            columns={columns}
            search
          >
            {(props) => (
              <React.Fragment>
                <Row className="align-items-end" style={{ marginLeft: -5, marginRight: -5, marginBottom: 8 }}>
                  <Col style={{ maxWidth: '200px', paddingLeft: 5, paddingRight: 5 }}>
                    <div style={{ marginBottom: '0px' }}>
                      <SearchBar {...props.searchProps} />
                    </div>
                  </Col>
                  <Col style={{ maxWidth: '40px', paddingLeft: 5, paddingRight: 5 }}>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => downloadTableData(props.baseProps.data)}
                      style={{ marginBottom: '5px' }} // Align roughly with search bar input? Search bar usually has some height.
                    >
                      <i className="bi bi-download"></i>
                    </Button>
                  </Col>
                  <Col className="ml-auto" style={{ maxWidth: '100px', paddingLeft: 5, paddingRight: 5 }}>
                    <Label style={{ fontSize: '0.8rem', marginBottom: 0 }}>Storewide</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={storewideFilter}
                      onChange={(e) => setStorewideFilter(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </Input>
                  </Col>
                  <Col style={{ maxWidth: '90px', paddingLeft: 5, paddingRight: 5 }}>
                    <Label style={{ fontSize: '0.8rem', marginBottom: 0 }}>Steep</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={steepFilter}
                      onChange={(e) => setSteepFilter(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </Input>
                  </Col>
                  <Col style={{ maxWidth: '100px', paddingLeft: 5, paddingRight: 5 }}>
                    <Label style={{ fontSize: '0.8rem', marginBottom: 0 }}>Significant</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={significantFilter}
                      onChange={(e) => setSignificantFilter(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </Input>
                  </Col>
                  <Col style={{ maxWidth: '100px', paddingLeft: 5, paddingRight: 5 }}>
                    <Label style={{ fontSize: '0.8rem', marginBottom: 0 }}>Clearance</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={clearanceFilter}
                      onChange={(e) => setClearanceFilter(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </Input>
                  </Col>
                  <Col style={{ maxWidth: '110px', paddingLeft: 5, paddingRight: 5 }}>
                    <Label style={{ fontSize: '0.8rem', marginBottom: 0 }}>Desperation</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={desperationFilter}
                      onChange={(e) => setDesperationFilter(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </Input>
                  </Col>
                </Row>
                <BootstrapTable
                  {...props.baseProps}
                  bordered={false}
                  rowStyle={{ fontWeight: "bold" }}
                  pagination={paginationFactory({
                    sizePerPage: 30,
                    showTotal: true,
                  })}
                  wrapperClasses="table-responsive"
                />
              </React.Fragment>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>

      <Modal isOpen={imageModal.modal} toggle={imageModal.toggle} size="lg" centered>
        <ModalHeader toggle={imageModal.toggle}>Image Preview</ModalHeader>
        <ModalBody className="text-center" style={{ overflow: "hidden", position: "relative" }}>
          {imageModal.loading ? (
            <Spinner color="primary" />
          ) : imageModal.error ? (
            <div className="text-danger">{imageModal.error}</div>
          ) : (
            <div
              onWheel={imageModal.handleWheel}
              onMouseDown={imageModal.handleMouseDown}
              onMouseMove={imageModal.handleMouseMove}
              onMouseUp={imageModal.handleMouseUp}
              onMouseLeave={imageModal.handleMouseUp}
              onDoubleClick={imageModal.handleDoubleClick}
              style={{
                cursor: imageModal.zoom > 1 ? (imageModal.isDragging ? "grabbing" : "grab") : "default",
                display: "inline-block",
              }}
            >
              <img
                src={imageModal.imageSrc}
                alt="Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  transform: `scale(${imageModal.zoom}) translate(${imageModal.position.x / imageModal.zoom}px, ${imageModal.position.y / imageModal.zoom}px)`,
                  transition: imageModal.isDragging ? "none" : "transform 0.1s ease-out",
                  userSelect: "none",
                }}
                draggable={false}
              />
            </div>
          )}
        </ModalBody>
      </Modal>
    </div >
  );
};

export default HarmonicDiscountTable;
